import {
  BASE
} from "./chunk-IBEWOW4A.mjs";
import {
  init_react_import
} from "./chunk-65BGW52G.mjs";

// components/Spacer/Spacer.ts
init_react_import();
import styled from "styled-components";
var Spacer = styled.div.attrs(() => ({
  "aria-hidden": true
}))`
  height: ${({ height = 5 }) => height * BASE}px;
  width: ${({ width = 0 }) => width * BASE}px;
  flex: none;
`;
var Spacer_default = Spacer;

export {
  Spacer_default
};
//# sourceMappingURL=chunk-SM5USSXF.mjs.map